import { useLessons } from '@/packages/corporate-university/context/lessons';
import { PdfLesson } from '@/packages/corporate-university/pages/course-by-id/components/pdf-lesson';
import { VideoLesson } from '@/packages/corporate-university/pages/course-by-id/components/video-lesson';

export const CurrentLesson = () => {
  const { currentLesson } = useLessons();
  const lessonType = currentLesson?.type;
  return lessonType === 'video' ? <VideoLesson /> : <PdfLesson />;
};
